export { default as SoundService } from './SoundService';



// WEBPACK FOOTER //
// ./src/modules/sound/services/index.js